import { render, staticRenderFns } from "./recomm.vue?vue&type=template&id=046f78c2&scoped=true&"
import script from "./recomm.vue?vue&type=script&lang=js&"
export * from "./recomm.vue?vue&type=script&lang=js&"
import style0 from "./recomm.vue?vue&type=style&index=0&id=046f78c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046f78c2",
  null
  
)

export default component.exports